<template>
  <div class="showcase">
    <NavbarComp />
    <div id="headerSection">
      <div id="leftHeader">
        <h1>Project Showcase</h1>
        <h2>Hallo teman-teman! Berikut showcase/portofolio dari beberapa teman-teman kita yang sudah bergabung bersama kami. <br> Yuk lihat !!!</h2>
      </div>
      <div id="rightHeader">
        <img src="../assets/picShowcase.png" />
      </div>
    </div>
    <div class="container-2 mt-5">
      <div class="row g-3">
        <div class="col-md" id="cekot">
          <select
            class="form-select"
            id="cekit"
            aria-label="Default select example"
          >
            <option selected>Terbaru</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>
        </div>
        <div class="col-md">
          <select
            class="form-select"
            id="cekit"
            aria-label="Default select example"
          >
            <option selected>Semua Kategori</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>
        </div>
        <div class="col-md">
          <input class="form-control col-md" placeholder="Cari Portofolio" />
        </div>
      </div>
      <div class="row mt-5">
        <!-- card 1 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/showcase1.png"
              alt="blog 1"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">
                Terry Dias
                <span class="card-item">&#40;Web Development&#41;</span>
              </h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-showcase">
                  <a href="#" class="btn btn-primary"> Lihat Showcase </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 2 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/showcase2.png"
              alt="blog 1"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">
                Martin Donin
                <span class="card-item">&#40;Web Development&#41;</span>
              </h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-showcase">
                  <a href="#" class="btn btn-primary"> Lihat Showcase </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 3 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/showcase3.png"
              alt="blog 1"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">
                Tatiana Franci
                <span class="card-item">&#40;Data Science&#41;</span>
              </h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-showcase">
                  <a href="#" class="btn btn-primary"> Lihat Showcase </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 4 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/showcase4.png"
              alt="blog 1"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">
                Livia Press
                <span class="card-item">&#40;Data Science&#41;</span>
              </h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-showcase">
                  <a href="#" class="btn btn-primary"> Lihat Showcase </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 5 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/showcase5.png"
              alt="blog 1"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">
                Brandon Vaccaro
                <span class="card-item">&#40;Data Science&#41;</span>
              </h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-showcase">
                  <a href="#" class="btn btn-primary"> Lihat Showcase </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 6 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/showcase6.png"
              alt="blog 1"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">
                Charlie Sipon
                <span class="card-item">&#40;Web Development&#41;</span>
              </h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-showcase">
                  <a href="#" class="btn btn-primary"> Lihat Showcase </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 7 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/showcase7.png"
              alt="blog 1"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">
                Craig Ekstrom B
                <span class="card-item">&#40;Data Science&#41;</span>
              </h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-showcase">
                  <a href="#" class="btn btn-primary"> Lihat Showcase </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 8 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/showcase8.png"
              alt="blog 1"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">
                Tiana Saris
                <span class="card-item">&#40;Data Science&#41;</span>
              </h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-showcase">
                  <a href="#" class="btn btn-primary"> Lihat Showcase </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 9 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/showcase9.png"
              alt="blog 1"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">
                Ashlynn Torff
                <span class="card-item">&#40;Data Science&#41;</span>
              </h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-showcase">
                  <a href="#" class="btn btn-primary"> Lihat Showcase </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-3 mt-4">
        <nav aria-label="Page navigation example">
          <ul class="pagination justify-content-center">
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item"><a class="page-link" href="#">4</a></li>
            <li class="page-item"><a class="page-link" href="#">5</a></li>
            <li class="page-item"><a class="page-link" href="#">6</a></li>
            <li class="page-item"><a class="page-link" href="#">7</a></li>
            <li class="page-item"><a class="page-link" href="#">...</a></li>
            <li class="page-item"><a class="page-link" href="#">50</a></li>
            <li class="page-item">
              <a class="page-link" href="#" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <FooterComp />
  </div>
</template>

<script>
import NavbarComp from "../components/NavbarComp.vue";
import FooterComp from "../components/FooterComp.vue";
export default {
  name: `ShowcaseComp`,
  components: {
    NavbarComp,
    FooterComp,
  },
};
</script>

<style scoped>
#headerSection {
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
  background-color: #f5f5f5;
}
#headerSection #leftHeader {
  width: 900px;
  margin-top: 138px;
  margin-bottom: 138px;
  margin-left: 70px;
  position: absolute;
  text-align: center;
}
#headerSection #leftHeader h1 {
  font-size: 32px;
  font-weight: 600;
  color: #ff5400;
}
#headerSection #leftHeader h2 {
  margin-top: 20px;
  font-size: 26px;
  font-weight: 400;
  color: #023047;
}
#headerSection #rightHeader img {
  margin-top: 30px;
  margin-left: 1000px;
  width: 246px;
  height: 377px;
}
.showcase .card-title {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 140%;
  letter-spacing: 0.005em;
  color: #ff5400;
}
.showcase .card-category {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0.005em;
  color: #023047;
}
.showcase .card-item {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  letter-spacing: 0.005em;
  color: #023047;
}
#cekit {
  color: #ff5400;
}
#cekot {
  color: #ff5400;
}

@media only screen and (max-width: 500px) {
  #headerSection #leftHeader {
    width: 60%;
    margin-top: 80px;
    margin-bottom: 100px;
    margin-left: 0px;
  }
  #headerSection #leftHeader h1 {
    font-size: 16px;
  }
  #headerSection #leftHeader h2 {
    font-size: 10px;
    width: 100%;
    padding: 0 10px;
  }
  #headerSection #rightHeader {
    margin-top: 50px;
    margin-left: 60%;
  }
  #headerSection #rightHeader img {
    margin-left: 0;
    width: 98px;
    height: 150px;
  }
  .form-select , .form-control {
    font-size: 14px;
  }
  .showcase .card-category {
    font-size: 14px;
  }
  .card-category .card-item {
    font-size: 15px;
  }
  .container-2 {
    padding: 0;
  }
  .card {
    margin-left: 20%;
    margin-bottom: 20px;
    width: 60%;
  }
  #card-title-blog {
    font-size: 14px;
  }
  .card-category {
    font-size: 12px;
  }
  .card-text {
    font-size: 10px;
  }
  #button a {
    font-size: 12px;
  }
  .container-3 {
    margin-left: 0%;
  }
  .page-item {
    width: 20px;
  }
  .page-item a {
    padding: 5px;
    font-size: 12px;
  }
}
</style>